import { useState } from "react";
import LoadingButton from "../common/LoadingButton";

export default function PasswordResetViaCodeForm({
    password,
    confirmPassword,
    onPasswordChange,
    onConfirmChange,
    errors,
    matchError,
    onSubmit,
    t
}) {
    const [isNewPasswordTouched, setIsNewPasswordTouched] = useState(false);
    const [isConfirmPasswordTouched, setIsConfirmPasswordTouched] = useState(false);

    const {
        length: meetsLengthRequirement,
        upper: hasUppercaseLetter,
        special: hasSpecialCharacter,
        digit: hasDigitCharacter
    } = errors;

    const [isNewPasswordVisible, setIsNewPasswordVisible] = useState(false);
    const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] = useState(false);

    const toggleNewPasswordVisibility = () => setIsNewPasswordVisible(v => !v);
    const toggleConfirmPasswordVisibility = () => setIsConfirmPasswordVisible(v => !v);

    const shouldShowPasswordRules =
        isNewPasswordTouched &&
        password &&
        !(meetsLengthRequirement && hasUppercaseLetter && hasSpecialCharacter && hasDigitCharacter);

    const isSubmittable =
        meetsLengthRequirement &&
        hasUppercaseLetter &&
        hasSpecialCharacter &&
        hasDigitCharacter &&
        confirmPassword.trim() !== "" &&
        confirmPassword === password;

    return (
        <div className="pwd-panel flex flex-column w-full gap-2 px-4 py-2">
            <label
                htmlFor="new_password"
                className="keduall-typography text-16-normal-400 text-default required"
            >
                {t.passwordInputLabel}
            </label>

            <div className="p-inputgroup relative">
                <input
                    name="new_password"
                    type={isNewPasswordVisible ? "text" : "password"}
                    className="keduall-form form-input-default-filled-large w-full keduall-typography text-16-normal-400 custom-password-input validate"
                    autoComplete="new-password"
                    value={password}
                    onChange={(e) => {
                        setIsNewPasswordTouched(true);
                        onPasswordChange(e.target.value);
                    }}
                    onBlur={() => setIsNewPasswordTouched(true)}
                />
                <span className="p-inputgroup-addon keduall-icon password-icon-wrapper">
                    <i
                        className={isNewPasswordVisible ? "pi pi-eye" : "pi pi-eye-slash"}
                        onClick={toggleNewPasswordVisibility}
                    />
                </span>
            </div>

            <small className={`keduall-typography text-danger-txt text-14-normal-400 ${isNewPasswordTouched && !password ? "" : "visibility-hidden"}`}
            >
                {t.passwordInputRequiredLabel}
            </small>

            {shouldShowPasswordRules && (
                <div className="keduall-typography text-danger-txt text-14-normal-400">
                    <div>{t.passwordStrengthValidation}</div>

                    {[
                        { id: "lengthReq", isSatisfied: meetsLengthRequirement, text: t.lengthReqText },
                        { id: "upperReq", isSatisfied: hasUppercaseLetter, text: t.upperReqText },
                        { id: "specialReq", isSatisfied: hasSpecialCharacter, text: t.specialReqText },
                        { id: "digitReq", isSatisfied: hasDigitCharacter, text: t.digitReqText }
                    ].map(({ id, isSatisfied, text }) => (
                        <div key={id} id={id} className="align-items-center flex flex-row gap-0625">
                            <p className="flex">- {text}</p>
                            <i
                                className={
                                    `flex justify-content-center align-items-center ` +
                                    `${isSatisfied ? 'pi pi-check keduall-icon validation-success-icon'
                                        : 'pi pi-times keduall-icon validation-fail-icon'}`
                                }
                            />
                        </div>
                    ))}
                </div>
            )}

            <label
                htmlFor="confirm_password"
                className="keduall-typography text-16-normal-400 text-default required mt-2"
            >
                {t.confirmPasswordInputLabel}
            </label>

            <div className="p-inputgroup relative">
                <input
                    name="confirm_password"
                    type={isConfirmPasswordVisible ? "text" : "password"}
                    className="keduall-form form-input-default-filled-large w-full keduall-typography text-16-normal-400 custom-password-input validate"
                    autoComplete="new-password"
                    value={confirmPassword}
                    onChange={(e) => {
                        setIsConfirmPasswordTouched(true);
                        onConfirmChange(e.target.value);
                    }}
                    onBlur={() => setIsConfirmPasswordTouched(true)}
                />
                <span className="p-inputgroup-addon keduall-icon password-icon-wrapper">
                    <i
                        className={isConfirmPasswordVisible ? "pi pi-eye" : "pi pi-eye-slash"}
                        onClick={toggleConfirmPasswordVisibility}
                    />
                </span>
            </div>

            <div
                className={`keduall-typography text-danger-txt text-14-normal-400 ${isConfirmPasswordTouched && matchError ? "" : "visibility-hidden"
                    }`}
            >
                {t.passwordInputNotMatch}
            </div>

            <LoadingButton
                className="reset_submit keduall-buttons button-filled-default-large-primary flex-1 keduall-typography heading-h6-semibold-600 text-white-txt"
                onClick={onSubmit}
                label={t.resetButtonLabel}
                disabled={!isSubmittable}
            />
        </div>
    );
}